import React from 'react';
import PropTypes from 'prop-types';
import CloseWindowButton from '../../../../../../atomic/buttons/closeWindow/CloseWindowButton';
import style from './PositionModuleWrapper.module.css';
import ScalingInModule from '../modules/ScalingInModule';
import AddToWinnerModule from '../modules/AddToWinnerModule';


export default function PositionModuleWrapper({
  type,
  index,
  removeTactic,
  stateProps,
}) {
  let component;
  let setter;
  switch (type) {
    case 'Scaling In':
      component = <ScalingInModule state={stateProps.scalingIn} top={stateProps.top} />;
      setter = stateProps.scalingIn[3];
      break;
    case 'Add To Winner':
      component = <AddToWinnerModule state={stateProps.addToWinner} top={stateProps.top} />;
      setter = stateProps.addToWinner[3];
      break;
    default:
      break;
  }
  return (
    <div className={style.wrapper}>
      {component}
      <CloseWindowButton
        width={10}
        color="red"
        stroke={3}
        display="block"
        handleClick={() => {
          removeTactic(index);
          setter(false);
        }}
      />
    </div>
  );
}

PositionModuleWrapper.propTypes = {
  type: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  removeTactic: PropTypes.func.isRequired,
  stateProps: PropTypes.object.isRequired,
};
